<template>
    <span v-if="unsubscribed.length > 0" @click="showList = !showList">
        <span class="unsubscribed ">
            {{unsubscribed.length}} missing SMS opt-ins
        </span>
        <ul v-if="showList" class="number_list" @click.stop>
            <li v-for="item in unsubscribed" :key="item">
                <a style="color:blue" :href="editURL(item.driver_id)">
                    {{ item.phone }} -- {{ item.driver.first_name }} {{ item.driver.last_name }} 
                </a>
            </li>
        </ul>
    </span>
</template>

<script>
    import config from '../config'

    export default {
      data () {
        return {
          unsubscribed: [],
          showList : false
        }
      },
      created() {
        this.refresh()
      },
      methods: {
        refresh () { //TODO this should not be here
          //get the unsubscribed numbers
          let url = `${config.stockbookUrl}/api/v2/canttext`
          fetch(url, {headers: {'Authorization': 'Basic ' + localStorage.credentials}})
          .then(res => res.json())
          .then(json => {
            this.unsubscribed = json
            console.log(json)
          })
          .catch(err => console.log)
        },
        editURL(id) {
                return `${config.stockbookUrl}/users/edit/${id}/`;
            }

      }
    }
</script>

<style lang="less" scoped>
    /* Flash class and keyframe animation */
    .unsubscribed {
      color: red;
      -webkit-animation: flash linear 1s infinite;
      animation: flash linear 1s infinite;
      margin: 1em;
    }
    @-webkit-keyframes flash {
      0% { opacity: 1; }
      50% { opacity: .1; }
      100% { opacity: 1; }
    }
    @keyframes flash {
      0% { opacity: 1; }
      50% { opacity: .1; }
      100% { opacity: 1; }
    }
    .number_list
    {
      position: absolute;
      background-color: white;
      color: black;
      text-align: left;
    }
</style>